

import React,
{
  useState,
  useEffect,
} from "react";

export default function PaymentEditModal({

  invoice,

  onClose,

  onSave,

  loading,
}) {

  // =====================================
  // FORM
  // =====================================
  const [formData, setFormData] =
    useState({

      total_amount: "",

      payment_date: "",

      payment_reference_number: "",
    });

  // =====================================
  // LOAD INVOICE
  // =====================================
  useEffect(() => {

    if (invoice) {

      setFormData({

        total_amount:
          invoice.total_amount || "",

        payment_date:
          invoice.payment_date || "",

        payment_reference_number:
          invoice.payment_reference_number || "",
      });
    }

  }, [invoice]);

  // =====================================
  // NO INVOICE
  // =====================================
  if (!invoice) {
    return null;
  }

  // =====================================
  // SAVE
  // =====================================
  const handleSave =
    () => {

      onSave({

        ...formData,

        payment_status:
          formData.payment_reference_number
            ? "PAID"
            : "UNPAID",
      });
    };

  return (

    <div
      className="modal-overlay"
      style={{

        position: "fixed",

        inset: 0,

        background:
          "rgba(15,23,42,0.65)",

        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        zIndex: 9999,

        padding: "20px",
      }}
    >

      {/* =====================================
          MODAL
      ===================================== */}

      <div
        className="modal-card"
        style={{

          width: "900px",

          maxHeight: "90vh",

          overflowY: "auto",

          background: "#fff",

          borderRadius: "24px",

          padding: "35px",

          boxShadow:
            "0 20px 60px rgba(0,0,0,0.18)",
        }}
      >

        {/* =====================================
            HEADER
        ===================================== */}

        <div
          style={{
            marginBottom: "30px",
          }}
        >

          <h2
            style={{
              margin: 0,
            }}
          >
            Payment Reconciliation
          </h2>

          <p
            style={{
              color: "#64748b",
              marginTop: "8px",
            }}
          >
            Manual invoice correction
          </p>

        </div>

        {/* =====================================
            READ ONLY INFO
        ===================================== */}

        <div
          style={{

            display: "grid",

            gridTemplateColumns:
              "repeat(2, 1fr)",

            gap: "18px",

            marginBottom: "35px",
          }}
        >

          <ReadOnlyField
            label="Invoice Number"
            value={
              invoice.invoice_number
            }
          />

          <ReadOnlyField
            label="Vendor"
            value={
              invoice.vendor
            }
          />

          <ReadOnlyField
            label="Invoice Date"
            value={
              invoice.invoice_date
            }
          />

          <ReadOnlyField
            label="Service Period"
            value={
              invoice.service_period
            }
          />

          <ReadOnlyField
            label="Customer Account"
            value={
              invoice.customer_account_number
            }
          />

          <ReadOnlyField
            label="Billing Quarter"
            value={
              invoice.billing_quarter
            }
          />

          <ReadOnlyField
            label="GST Number"
            value={
              invoice.sisl_gst
            }
          />

          <ReadOnlyField
            label="State Code"
            value={
              invoice.sisl_state_code
            }
          />

        </div>

        {/* =====================================
            EDIT SECTION
        ===================================== */}

        <div
          style={{
            borderTop:
              "1px solid rgba(148,163,184,0.18)",

            paddingTop: "30px",
          }}
        >

          <h3
            style={{
              marginBottom: "20px",
            }}
          >
            Payment Details
          </h3>

          <div
            style={{

              display: "grid",

              gridTemplateColumns:
                "repeat(2, 1fr)",

              gap: "20px",
            }}
          >

            {/* AMOUNT */}

            <EditableField

              label="Total Amount"

              type="number"

              value={
                formData.total_amount
              }

              onChange={(e) =>
                setFormData({

                  ...formData,

                  total_amount:
                    e.target.value,
                })
              }
            />

            {/* PAYMENT DATE */}

            <EditableField

              label="Payment Date"

              type="date"

              value={
                formData.payment_date
              }

              onChange={(e) =>
                setFormData({

                  ...formData,

                  payment_date:
                    e.target.value,
                })
              }
            />

            {/* REFERENCE */}

            <EditableField

              label="Payment Reference Number"

              type="text"

              value={
                formData.payment_reference_number
              }

              onChange={(e) =>
                setFormData({

                  ...formData,

                  payment_reference_number:
                    e.target.value,
                })
              }
            />

          </div>

        </div>

        {/* =====================================
            ACTIONS
        ===================================== */}

        <div
          style={{

            display: "flex",

            justifyContent: "flex-end",

            gap: "15px",

            marginTop: "35px",
          }}
        >

          <button

            onClick={onClose}

            style={{

              padding:
                "12px 22px",

              borderRadius:
                "12px",

              border:
                "1px solid rgba(148,163,184,0.25)",

              background:
                "#fff",

              cursor: "pointer",

              fontWeight: "600",
            }}
          >
            Cancel
          </button>

          <button

            onClick={handleSave}

            disabled={loading}

            style={{

              padding:
                "12px 24px",

              borderRadius:
                "12px",

              border: "none",

              background:
                "#2563eb",

              color: "#fff",

              cursor: "pointer",

              fontWeight: "700",
            }}
          >

            {loading
              ? "Saving..."
              : "Save Changes"}

          </button>

        </div>

      </div>

    </div>
  );
}

// =====================================
// READ ONLY FIELD
// =====================================
function ReadOnlyField({

  label,

  value,
}) {

  return (

    <div>

      <label
        style={{

          display: "block",

          marginBottom: "8px",

          fontSize: "13px",

          fontWeight: "600",

          color: "#64748b",
        }}
      >
        {label}
      </label>

      <div
        style={{

          background:
            "#f8fafc",

          padding:
            "14px 16px",

          borderRadius:
            "12px",

          border:
            "1px solid rgba(148,163,184,0.12)",

          fontWeight: "500",
        }}
      >
        {value || "-"}
      </div>

    </div>
  );
}

// =====================================
// EDITABLE FIELD
// =====================================
function EditableField({

  label,

  type,

  value,

  onChange,
}) {

  return (

    <div>

      <label
        style={{

          display: "block",

          marginBottom: "8px",

          fontSize: "13px",

          fontWeight: "600",

          color: "#64748b",
        }}
      >
        {label}
      </label>

      <input

        type={type}

        value={value}

        onChange={onChange}

        style={{

          width: "100%",

          padding:
            "14px 16px",

          borderRadius:
            "12px",

          border:
            "1px solid rgba(148,163,184,0.20)",

          outline: "none",

          fontSize: "15px",
        }}
      />

    </div>
  );
}